// extracted by mini-css-extract-plugin
module.exports = {"input":"CheckoutNote_input__3y4zK","label":"CheckoutNote_label__1Ry8S"};